<div class="invalid-feedback" *ngIf="control.invalid && !control.pristine">
    {{ message }}
</div>

<!-- <div class="valid-feedback" *ngIf="control.valid">
    Muito bem, o campo está preenchido corretamente.
</div> -->